import { axiosCore } from './http-core-service';
import { ConsommationsDto } from './dtos/consommations.dto';
import { ConfigConsommationsDto } from './dtos/config-consommations.dto';
import { ConsommationTelereleveDto } from './dtos/consommation-telereleve.dto';

/**
 * Appel API récupérant les factures paginées
 * @param contractId Contrat dont les factures sont à récupérer
 * @param sort tri des éléments
 */
export const getConsommations = async (contractId: string | undefined, sort?: string): Promise<ConsommationsDto> => {
    const response = await axiosCore.get(`/rattachement_contrats/${contractId}/consommations` + sort);
    return {
        consommations: response.data,
    };
};

/**
 * Appel API qui permet de récupérer les config graphique d'un contrat
 * @param contractId Contrat dont les factures sont à récupérer
 */
export const getConfigConsommations = async (contractId: string | undefined): Promise<ConfigConsommationsDto> => {
    const response = await axiosCore.get(`/rattachement_contrats/${contractId}/consommations/config`);
    return response.data?.pop();
};

/**
 * Appel API qui permet de récupérer les consommation téléverse d'un contrat
 * @param contractId Contrat dont les factures sont à récupérer
 * @param waterMeter Numéro du compteur
 * @param type type de données
 * @param start début des données
 * @param end fin des données
 */
export const getConsommationsTeleverse = async (
    contractId: string | undefined,
    waterMeter: string,
    type: string,
    start: string,
    end: string
): Promise<Array<ConsommationTelereleveDto>> => {
    const params = `?type=${type}&start=${start}&end=${end}&pagination=false`;
    const response = await axiosCore.get(
        `/rattachement_contrats/${contractId}/consommations/${waterMeter}/telereleve${params}`
    );
    return response.data;
};
